import { NibbleAction } from '@aipb/personal-content/shared/model';
import { openUrl } from '@aipb/util/routing';
import { NibbleActionHandler } from '../nibble-action.handler';

export class ImgNibbleActionHandler implements NibbleActionHandler {
  handle(nibbleAction: NibbleAction) {
    openUrl(this.getUrl(nibbleAction));
  }

  getUrl(nibbleAction: NibbleAction): string {
    return nibbleAction.nibbleCut.nibble.userValue;
  }

  useResolver(): boolean {
    return false;
  }
}
